import { Field } from '@availity/form';
import React from 'react';

interface MarketplacePercentFieldProps {
    name: string;
    value: string | number;
    setValue: (name: string, value: string) => void;
}

export const MarketplacePercentField = (
    props: MarketplacePercentFieldProps
) => {
    const validatePercentageField = (event: any, keyprop: any, prefix: any) => {
        const f = (x: any) =>
            x.toString().includes('.')
                ? x.toString().split('.').pop().length
                : 0;
        let isChangeAfterDot =
            (event.target as HTMLTextAreaElement).selectionStart >
            keyprop.toString().replace(prefix, '').length - 2;
        let isThreeDigitsAfterDot =
            f(keyprop.toString().replace(prefix, '')) >= 3;
        if (
            !/[0-9]/.test(event.key) &&
            event.key != 'Backspace' &&
            event.key != 'ArrowRight' &&
            event.key != 'ArrowLeft' &&
            event.key != 'Tab' &&
            (event.key != '.' || keyprop.toString().includes('.'))
        ) {
            return true;
        }

        if (event.key == '.' && !isChangeAfterDot) {
            return true;
        }

        if (
            /[0-9]/.test(event.key) &&
            isThreeDigitsAfterDot &&
            isChangeAfterDot
        ) {
            return true;
        }
        return false;
    };

    return (
        <Field
            type="text"
            name={props.name}
            value={(props.value?.toString() ?? '0') + '%'}
            min={1}
            max={100}
            onKeyDown={(event) => {
                if (validatePercentageField(event, props.value, '%')) {
                    event.preventDefault();
                }
            }}
            onChange={(event) => {
                let value = event.target.value;

                if (
                    !event.target.value.includes('%') &&
                    Number(value) === Number(props.value)
                ) {
                    value = event.target.value.slice(0, -1);
                }
                const res = value.replace('%', '');
                props.setValue(props.name, res);
            }}></Field>
    );
};
